var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M17.0303 7.75758C17.0303 10.3851 14.9003 12.5152 12.2727 12.5152C9.64519 12.5152 7.51515 10.3851 7.51515 7.75758C7.51515 5.13004 9.64519 3 12.2727 3C14.9003 3 17.0303 5.13004 17.0303 7.75758ZM16.7082 17.5645C17.6462 18.5025 18.2565 19.707 18.4653 21H6.0802C6.28899 19.707 6.89924 18.5025 7.83723 17.5645L7.13013 16.8574L7.83724 17.5645C9.01359 16.3881 10.6091 15.7273 12.2727 15.7273C13.9364 15.7273 15.5319 16.3881 16.7082 17.5645L17.4153 16.8574L16.7082 17.5645Z",
      stroke: "#041F47",
      strokeWidth: 2
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPerson, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/person.227e73b1.svg";
export { ForwardRef as ReactComponent };